var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNftbeeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.6059 114.526V122.889L57.4443 98.6655V76.3835L64.7209 81.9302V94.4839L99.6059 114.526Z",
    fill: "url(#paint0_linear_95_538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3586 63.4053L73.082 59.2063V89.6826L80.3586 85.4879V63.4053Z",
    fill: "url(#paint1_linear_95_538)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.13 59.2064V89.6827H126.125L118.849 85.488V63.3881L99.6055 52.3294V43.9661L126.121 59.2021L126.13 59.2064Z",
    fill: "url(#paint2_linear_95_538)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.849 85.5009L99.6055 96.5552V104.923L126.125 89.6826L118.849 85.4879V85.5009Z",
    fill: "url(#paint3_linear_95_538)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M141.763 50.2233V98.6656L123.247 109.304L116.994 104.533L134.486 94.4839V54.405L99.6059 34.3633L64.7209 54.405V81.9303L57.4443 76.3836V50.2233L57.4574 50.2146L99.6059 26L141.75 50.2146L141.763 50.2233Z",
    fill: "url(#paint4_linear_95_538)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 174V135H17.6047L34.0304 161.156V135H42.0995V174H33.4512L17.0778 147.896V174H9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6641 174V135H77.2115V142.211H58.2732V151.22H74.6814V157.88H58.2732V174H49.6641Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1357 135V142.211H90.8932V174H99.5111V142.215V135H79.1357Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M133.891 166.785V157.23H152.877V150.57H133.891V142.215H154.584V135H125.277V136.235C128.726 137.711 130.449 140.521 130.446 144.663C130.501 146.368 130.036 148.049 129.114 149.487C128.192 150.924 126.854 152.051 125.277 152.719V152.845C129.96 154.26 132.301 157.542 132.301 162.69C132.375 164.37 132.022 166.041 131.275 167.549C130.527 169.057 129.409 170.353 128.025 171.318C127.172 171.927 126.246 172.427 125.269 172.808V174H155.011V166.785H133.891Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.832 174V135H190.139V142.211H169.45V150.561H188.436V157.23H169.45V166.785H190.574V174H160.832Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.101 146.15C122.101 146.306 122.101 146.462 122.101 146.613C122.106 146.668 122.106 146.723 122.101 146.778C122.101 146.908 122.084 147.034 122.049 147.155C122.053 147.19 122.053 147.224 122.049 147.259C121.978 147.725 121.831 148.175 121.614 148.594C121.557 148.711 121.491 148.824 121.418 148.932C121.392 148.966 121.366 149.01 121.339 149.04C121.289 149.116 121.234 149.188 121.174 149.257C121.147 149.292 121.118 149.325 121.087 149.356C121 149.452 120.913 149.538 120.817 149.625C120.721 149.712 120.617 149.785 120.512 149.859C120.469 149.891 120.424 149.92 120.377 149.946C120.148 150.1 119.902 150.229 119.645 150.331C119.519 150.379 119.384 150.427 119.249 150.466L119.114 150.509C118.97 150.548 118.814 150.587 118.679 150.617C118.496 150.656 118.311 150.685 118.126 150.704L117.525 150.765C117.32 150.765 117.089 150.765 116.889 150.765H108.18V141.665H116.728C116.844 141.656 116.96 141.656 117.076 141.665C117.303 141.665 117.512 141.695 117.734 141.721C117.838 141.721 117.947 141.747 118.052 141.764C118.361 141.812 118.67 141.877 118.975 141.955C119.071 141.985 119.166 142.007 119.262 142.042L119.528 142.133C119.792 142.233 120.048 142.353 120.294 142.492C120.294 142.492 120.32 142.492 120.329 142.518C120.442 142.58 120.55 142.651 120.651 142.731C120.756 142.809 120.86 142.895 120.956 142.982L121 143.021C121.016 143.032 121.031 143.045 121.043 143.06C121.116 143.129 121.184 143.203 121.248 143.281C121.316 143.356 121.379 143.435 121.435 143.519C121.462 143.555 121.487 143.593 121.509 143.632C121.527 143.645 121.541 143.663 121.548 143.684C121.563 143.703 121.574 143.723 121.583 143.745C121.633 143.826 121.678 143.91 121.718 143.996C121.778 144.116 121.832 144.239 121.879 144.364C121.914 144.465 121.945 144.565 121.971 144.663C121.989 144.714 122.004 144.766 122.014 144.819C122.067 145.036 122.106 145.256 122.132 145.478C122.132 145.543 122.132 145.612 122.132 145.677C122.132 145.82 122.132 145.959 122.132 146.111",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.691 162.205C123.691 165.625 121.571 167.334 117.329 167.331H108.11V156.628H117.495C117.751 156.628 118.008 156.628 118.248 156.649L118.683 156.68C118.892 156.71 119.097 156.732 119.297 156.766C119.509 156.799 119.718 156.844 119.924 156.901L120.225 156.983C120.594 157.089 120.95 157.235 121.287 157.416L121.527 157.551C122.283 158.009 122.876 158.693 123.221 159.505C123.294 159.678 123.359 159.852 123.417 160.025C123.531 160.419 123.611 160.822 123.656 161.23C123.656 161.329 123.656 161.425 123.683 161.524C123.683 161.745 123.709 161.958 123.709 162.196",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_538",
    x1: 86.1501,
    y1: 117.602,
    x2: 63.4962,
    y2: 84.5867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FD6BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A32661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_95_538",
    x1: 76.544,
    y1: 77.9826,
    x2: 77.4581,
    y2: 48.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A22D60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_95_538",
    x1: 99.6055,
    y1: 66.8244,
    x2: 126.13,
    y2: 66.8244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85691"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F54C8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_95_538",
    x1: 98.2425,
    y1: 95.2032,
    x2: 151.282,
    y2: 95.2032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD6BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#93215C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_95_538",
    x1: 58.0932,
    y1: 48.438,
    x2: 148.122,
    y2: 81.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FC67A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD225F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftbeeLogo);
export default __webpack_public_path__ + "static/media/nftbeeLogo.3815ff3c5f4cfb3ec2700b08116697e1.svg";
export { ForwardRef as ReactComponent };